import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: 'root',
  })

  export class ErrorHandlerService {
    constructor(private toastr: ToastrService) {}

    public handleError(error: Error | HttpErrorResponse, errMsg?: string): void {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 200 && error.error?.status === 'error') {
          // Handle specific error case
          console.error('Server-side error:', error.error.result);
          this.toastr.error(error.error.result || 'An error occurred. Please try again later.');
        } else {
          // Handle other HTTP errors
          console.error(`Server-side error: ${error.status} - ${error.message}`);
          this.toastr.error(errMsg || error.statusText || 'An error occurred. Please try again later.');
        }
      } else {
        // Handle non-HTTP errors
        console.error('Error:', error.message);
        this.toastr.error(errMsg || error.message || 'An unexpected error occurred.');
      }
    }
  }
